import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'projects/selflearnv2-ui/src/app/modules/shared/module/material/material.module';
import { SelfLearnV2RoutingModule } from './self-learn-v2-routing.module';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelfLearnHomeComponent } from './components/self-learn-home/self-learn-home.component';
import { SelfLearnSidebarComponent } from './shared/components/self-learn-sidebar/self-learn-sidebar.component';
import { IconicSubjectComponent } from './shared/components/iconic-subject/iconic-subject.component';
import { VideoCardComponent } from './shared/components/video-card/video-card.component';
import { ShortsCardComponent } from './shared/components/shorts-card/shorts-card.component';
import { SelfLearnSubjectComponent } from './components/self-learn-subject/self-learn-subject.component';
import { AdsSidebarComponent } from './shared/components/ads-sidebar/ads-sidebar.component';
import { SubjectTopicHeaderComponent } from './shared/components/subject-topic-header/subject-topic-header.component';
import { TopicCardComponent } from './shared/components/topic-card/topic-card.component';
import { ChapterCardComponent } from './shared/components/chapter-card/chapter-card.component';
import { SelfLearnVideosComponent } from './components/self-learn-videos/self-learn-videos.component';
import { SelfLearnVideoPlaybackComponent } from './components/self-learn-video-playback/self-learn-video-playback.component';
import { PlaylistCardComponent } from './shared/components/playlist-card/playlist-card.component';
import { SelfLearnChapterComponent } from './components/self-learn-chapter/self-learn-chapter.component';
import { ChapterLearnTabComponent } from './components/self-learn-chapter/chapter-learn-tab/chapter-learn-tab.component';
import { ChapterPracticeTabComponent } from './components/self-learn-chapter/chapter-practice-tab/chapter-practice-tab.component';
import { ChapterReviseTabComponent } from './components/self-learn-chapter/chapter-revise-tab/chapter-revise-tab.component';
import { PracticeCardComponent } from './shared/components/practice-card/practice-card.component';
import { PypCardComponent } from './shared/components/pyp-card/pyp-card.component';
import { PopularBookCardComponent } from './shared/components/popular-book-card/popular-book-card.component';
import { PracticeTestCardComponent } from './shared/components/practice-test-card/practice-test-card.component';
import { TopicSummaryCardComponent } from './shared/components/topic-summary-card/topic-summary-card.component';
import { StoriesBannerCardComponent } from './shared/components/stories-banner-card/stories-banner-card.component';
import { MemoryBannerCardComponent } from './shared/components/memory-banner-card/memory-banner-card.component';
import { BookmarkCardComponent } from './shared/components/bookmark-card/bookmark-card.component';
import { TopicSummaryDetailsComponent } from './components/topic-summary-details/topic-summary-details.component';
import { TopicsSummaryComponent } from './components/topics-summary/topics-summary.component';
import { TopicSidebarComponent } from './components/topic-summary-details/topic-sidebar/topic-sidebar.component';
import { QuitPracticeDialogComponent } from './components/quit-practice-dialog/quit-practice-dialog.component';
import { StartTestDialogComponent } from './components/start-test-dialog/start-test-dialog.component';
import { TestInstructionDialogComponent } from './components/test-instruction-dialog/test-instruction-dialog.component';
import { PracticeQuestionsComponent } from './components/practice-questions/practice-questions.component';
import { ShortsComponent } from './components/shorts/shorts.component';
import { ShortsErrorDialogComponent } from './components/shorts-error-dialog/shorts-error-dialog.component';
import { ParcticeCompletionComponent } from './components/parctice-completion/parctice-completion.component';
import { ExcerciseProgressDialogComponent } from './components/excercise-progress-dialog/excercise-progress-dialog.component';
import { LearnCompletedDialogComponent } from './components/learn-completed-dialog/learn-completed-dialog.component';
import { NoContentCardComponent } from './shared/components/no-content-card/no-content-card.component';
import { LevelupDialogComponent } from './components/levelup-dialog/levelup-dialog.component';
import { StoriesDialogComponent } from './components/stories-dialog/stories-dialog.component';
import { StoryCardComponent } from './shared/components/story-card/story-card.component';
import { PracticeTopicListComponent } from './components/practice-topic-list/practice-topic-list.component';
import { StartReviseComponent } from './components/start-revise/start-revise.component';
import { ReviceQuestionsComponent } from './components/revice-questions/revice-questions.component';
import { MathModule } from '../../shared/directives/math/math.module';
import { ReviseCompletionComponent } from './components/revise-completion/revise-completion.component';
import { MathMlModule } from '../../shared/directives/math-ml/math-ml.module';
import { UnclockChaptersComponent } from './shared/components/unclock-chapters/unclock-chapters.component';
import { BooksDialogComponent } from './components/books-dialog/books-dialog.component';
import { UnlockChapterDialogComponent } from './components/unlock-chapter-dialog/unlock-chapter-dialog.component';
import { DocumentsPageComponent } from './components/documents-page/documents-page.component';
import { ViewImageDialogComponent } from './shared/components/view-image-dialog/view-image-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ViewPdfComponent } from './components/view-pdf/view-pdf.component';
import { SidebarLearnComponent } from '@app-modules/feature/dashboard/shared/sidebar-learn/sidebar-learn.component';
import { MyLibraryComponent } from './components/my-library/my-library.component';
import { FormulaSheetsBannerCardComponent } from './shared/components/formula-sheets-banner-card/formula-sheets-banner-card.component';
import { MemoryCardsComponent } from './components/memory-cards/memory-cards.component';
import { SliderComponent } from './components/slider/slider.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CardOfTheDayComponent } from './components/card-of-the-day/card-of-the-day.component';
import { MemoryCardCompletionDialogComponent } from './components/memory-card-completion-dialog/memory-card-completion-dialog.component';
import { ExerciseQuestionsComponent } from './components/exercise-questions/exercise-questions.component';
import { ResumeLearningCardComponent } from './shared/components/resume-learning-card/resume-learning-card.component';
import { ExerciseStartDialogComponent } from './components/exercise-start-dialog/exercise-start-dialog.component';
import { ExerciseCompletionDialogComponent } from './components/exercise-completion-dialog/exercise-completion-dialog.component';
import { ExerciseCompletionComponent } from './components/exercise-completion/exercise-completion.component';
import { InteractiveActivitiesComponent } from './shared/components/interactive-activities/interactive-activities.component';
import {ExerciseSolutionComponent} from './components/exercise-solution/exercise-solution.component';
import { UserFeedbackPopupComponent } from './shared/components/user-feedback-popup/user-feedback-popup.component'

import { BookmarksListComponent } from './components/bookmarks-list/bookmarks-list.component';
import { MemoryThumbCardComponent } from './shared/components/memory-thumb-card/memory-thumb-card.component';
import { QuestionsThumbCardComponent } from './shared/components/questions-thumb-card/questions-thumb-card.component';
import { BookmarksSubjectDialogComponent } from './components/bookmarks-subject-dialog/bookmarks-subject-dialog.component';
import {BookmarkVideoCardComponent } from './shared/components/bookmark-video-card/bookmark-video-card.component';
import {BookmarkTopicSummeryCardComponent} from './shared/components/bookmark-topic-summery-card/bookmark-topic-summery-card.component';
import { PypChapterQuestionsComponent } from './components/pyp-chapter-questions/pyp-chapter-questions.component';
import { PyqChapterCompletionComponent } from './components/pyq-chapter-completion/pyq-chapter-completion.component';
import { RevisitPyqDialogComponent } from './components/revisit-pyq-dialog/revisit-pyq-dialog.component';
import { HistoryListComponent } from './components/history-list/history-list.component';



import { YtVideosComponent } from './components/yt-videos/yt-videos.component';
@NgModule({
  declarations: [
    SelfLearnHomeComponent,
    SelfLearnSidebarComponent,
    IconicSubjectComponent,
    VideoCardComponent,
    ShortsCardComponent,
    SelfLearnSubjectComponent,
    AdsSidebarComponent,
    SubjectTopicHeaderComponent,
    TopicCardComponent,
    ChapterCardComponent,
    SelfLearnVideosComponent,
    SelfLearnVideoPlaybackComponent,
    PlaylistCardComponent,
    SelfLearnChapterComponent,
    ChapterLearnTabComponent,
    ChapterPracticeTabComponent,
    ChapterReviseTabComponent,
    PracticeCardComponent,
    PypCardComponent,
    PopularBookCardComponent,
    PracticeTestCardComponent,
    TopicSummaryCardComponent,
    StoriesBannerCardComponent,
    MemoryBannerCardComponent,
    BookmarkCardComponent,
    TopicSummaryDetailsComponent,
    TopicsSummaryComponent,
    TopicSidebarComponent,
    QuitPracticeDialogComponent,
    StartTestDialogComponent,
    TestInstructionDialogComponent,
    PracticeQuestionsComponent,
    ShortsComponent,
    ShortsErrorDialogComponent,
    ParcticeCompletionComponent,
    ExcerciseProgressDialogComponent,
    LearnCompletedDialogComponent,
    NoContentCardComponent,
    LevelupDialogComponent,
    StoriesDialogComponent,
    StoryCardComponent,
    PracticeTopicListComponent,
    StartReviseComponent,
    ReviceQuestionsComponent,
    ReviseCompletionComponent,
    UnclockChaptersComponent,
    BooksDialogComponent,
    UnlockChapterDialogComponent,
    DocumentsPageComponent,
    ViewImageDialogComponent,
    ViewPdfComponent,
    MyLibraryComponent,
    FormulaSheetsBannerCardComponent,
    ExerciseStartDialogComponent,
    ExerciseCompletionComponent,
    MemoryCardsComponent,
    SliderComponent,
    CardOfTheDayComponent,
    MemoryCardCompletionDialogComponent,
    ExerciseQuestionsComponent,
    ResumeLearningCardComponent,
    ExerciseStartDialogComponent,
    ExerciseCompletionDialogComponent,
    ExerciseCompletionComponent,
    InteractiveActivitiesComponent,
    ExerciseSolutionComponent,
    SidebarLearnComponent,
    YtVideosComponent,
    UserFeedbackPopupComponent,
    MemoryCardCompletionDialogComponent,
    BookmarksListComponent,
    MemoryThumbCardComponent,
    QuestionsThumbCardComponent,
    BookmarksSubjectDialogComponent,
    BookmarkVideoCardComponent,
    BookmarkTopicSummeryCardComponent,
    PypChapterQuestionsComponent,
    PyqChapterCompletionComponent,
    RevisitPyqDialogComponent,
    HistoryListComponent
  ],
  imports: [
    CommonModule,
    SelfLearnV2RoutingModule,
    IvyCarouselModule,
    MatSelectModule,
    MatTabsModule,
    NgApexchartsModule,
    NgbModule,
    MathModule,
    MaterialModule,
    MathMlModule,
    PdfViewerModule,
    BrowserAnimationsModule
  ],
  exports:[
    IvyCarouselModule
  ],
})
export class SelfLearnV2Module { }
